import { features } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-7xl">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-900 text-xs font-semibold">
            核心功能
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            你要的统计能力，一个都不少
          </h2>
          <p className="mt-4 text-foreground-600 leading-relaxed">
            从访客画像到来源追踪，StatFlow 提供站长真正需要的完整分析维度，帮你把流量变成看得懂的洞察。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="group rounded-lg border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-900 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${f.icon} text-xl`} />
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                {f.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}